import { jsx as e } from "react/jsx-runtime";
import { DrawerItems as o, DrawerHeader as t, Drawer as a } from "flowbite-react";
import { r as m } from "../../index-CJ0TdoNN.js";
import { theme as s } from "./theme.js";
const p = (r) => m.createPortal(/* @__PURE__ */ e(a, { ...r, theme: s }), document.body), d = Object.assign(p, {
  Header: t,
  Items: o
});
export {
  d as Drawer,
  d as default
};
